// For build size, we are only doing the polyfills we need
// Docs at: https://github.com/zloirock/core-js
import 'core-js/features/object/assign';
import 'core-js/features/promise';
import 'whatwg-fetch' // Fetch polyfill not supported by core-js

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme, withStyles } from '@material-ui/core/styles';
import 'typeface-montserrat';

import App from './App';
import './index.css';
import ReactGa from './utils/GoogleAnalyticsSetup';
import * as serviceWorker from './serviceWorker';

import CONSTANTS  from "./utils/Constants";

const primaryColor = "#0088ff";
const theme = createMuiTheme({
	breakpoints: {
		values: CONSTANTS.BREAKPOINTS
	},

	typography: {
		fontSize: "16",
		// Fantasy font for finding text not handled by mui
		// "fontFamily": "fantasy",

		// "system-ui" didn't work here because relies on postcss to process the attached css file & substitute in the
		// font listing which doesn't happen in JSS. Simple hack is to put in separate css, import, & let postcss handle.
		// Need to specify inherit here so MUI picks up system-ui from index.css. Benefit of the complexity is don't
		// need to maintain the families - should update as part of npm updates
		fontFamily: "inherit",
		// Hardcodable equivalent to what system-ui currently does
		// "fontFamily": "-apple-system, BlinkMacSystemFont, \“Segoe UI\”, \“Roboto\”, \“Oxygen\”, \“Ubuntu\”, \“Cantarell\”, \“Fira Sans\”, \“Droid Sans\”, \“Helvetica Neue\”, sans-serif;",
		useNextVariants: true, // https://material-ui.com/style/typography/#migration-to-typography-v2
	},

	palette:{
		primary: {
			main: primaryColor 
		},
	},

	overrides: {
	// 	MuiAppBar: {
	// 		colorPrimary: {
	// 			//backgroundColor: "#282d47", // our default dark blue / purple color
	// 			//backgroundColor: "#0088ff", // blue
	// 			//backgroundColor: "#ffb400", // yellow
	// 			//backgroundColor: "#ff8000", // orange
	// 		}
	// 	}
		MuiButton: {
			root: {
				//color: primaryColor,
				// fontSize: "0.9rem",
				// fontWeight: 350,

				"&$disabled": {
					color: "rgba(0, 0, 0, 0.54)" // TODO: how do we use the default theme values?
				}
			}
		},

		MuiIconButton: {
			root: {
				// TEMP: component library changed padding to 12 for some reason
				// https://github.com/mui-org/material-ui/issues/13385
				width: 48,
				height: 48,
				padding: 0
			}
		// },

		// MuiTooltip: {
		// 	tooltip: {
		// 		color: "#fff",
		// 		padding: 10,
		// 		borderRadius: 3,
		// 		backgroundColor: "#202632",

		// 		// arrow
		// 		"&:after": {
		// 			content: "no-close-quote",
		// 			position: "absolute",
		// 			top: "100%", /* At the bottom of the tooltip */
		// 			left: "50%",
		// 			marginLeft: -5,
		// 			borderWidth: 5,
		// 			borderStyle: "solid",
		// 			borderColor: "#202632 transparent transparent transparent"
		// 		}
		// 	}
		}
	},

	// drawer: {
	// 	width: 240
	// }
});

const styles = {
	'@global': {
		html: {
			// height: '100%',
			fontSize: `${theme.typography.fontSize}px`,
			[theme.breakpoints.up('lg')]: {
				/* base font for "desktop" / landscape tablets */
				fontSize: (0.875 * theme.typography.fontSize)+'px',
			}
		},
		body: {
			margin: 0,
			padding: 0,
			color: theme.palette.text.primary,
			fontSize: "1rem",
			backgroundColor: theme.palette.background.default,
		},
		a: {
			color: theme.palette.text.primary,
			textDecoration: "none",
			'&.primary': {
				color: theme.palette.primary.main,
			},
			'&.secondary': {
				color: theme.palette.secondary.main,
			},
		},
	},
};

const devineSourceType = () => {
	// Doesn't indicate production really, just a packaged build; could be
	// any environment
	if(process.env.NODE_ENV === 'production') {
		// Not local && not iframe, assume extension
		if(window === window.top) {
			console.info("window == window.top");
			// Overriding GA source for extensions only
			ReactGa.set({dataSource: 'extension'});
			return CONSTANTS.SOURCE_TYPES.EXTENSION;

		// iframe window != window.top - must be embedded
		} else {
			console.info("window != window.top");
			ReactGa.set({dataSource: 'widget'});
			return CONSTANTS.SOURCE_TYPES.EMBEDDED;
		}
	}

	return CONSTANTS.SOURCE_TYPES.LOCAL;
}

const AppRoot = withStyles(styles)((props) => {
	let sourceType = devineSourceType();

	return (
		<MuiThemeProvider theme={theme}>
			<BrowserRouter>
				<App sourceType={sourceType} />
			</BrowserRouter>
		</MuiThemeProvider>
	);
});

ReactDOM.render(<AppRoot />, document.getElementById('ssi_ssss'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
